export const tokenExpiredErrorName = 'TokenExpiredError';
